import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_NAME, IMAGES } from "../utils/constants";

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white py-8 sm:py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    <div className="text-center md:text-left">
                        <span className="text-2xl font-bold text-orange-400">
                          <img src={IMAGES.LOGO_WHITE} alt={t('common.appName')} className="h-8 sm:h-10 mx-auto md:mx-0"/>
                        </span>
                    </div>
                    <div className="text-center md:text-left">
                        <h4 className="font-semibold mb-3 sm:mb-4">{t('footer.links')}</h4>
                        <div className="space-y-2">
                            <a href="#" className="block text-gray-300 hover:text-white text-sm sm:text-base">{t('footer.privacy')}</a>
                            <a href="#" className="block text-gray-300 hover:text-white text-sm sm:text-base">{t('footer.terms')}</a>
                            <a href="#" className="block text-gray-300 hover:text-white text-sm sm:text-base">{t('footer.contacts')}</a>
                        </div>
                    </div>
                    <div className="text-center md:text-left mt-4 md:mt-0">
                        <p className="text-gray-400 text-xs sm:text-sm">
                            {t('footer.copyright', { year: currentYear, appName: APP_NAME })}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
